module.exports = __webpack_public_path__ + "img/home-face.a6b0d375.svg";